import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { CallApiGet, CallApiPost } from "../../Helper/serviceApi";
import {
  AD_HOC_CH_ORDER,
  CH_SRVC_TYPE,
  LINEHAUL_CUSTOMER_USER_TYPE_LIST,
  ORD_STS,
} from "../../../ConfigConstants/ConfigConstants";
import {
  ALPHABET_REGEX,
  initSrvcObj,
  NUMBER_NINE_DECIMAL,
  PATTERN_ERR_MSG,
  REQUIRED_ERR_MSG,
  SERVER_ERR_MSG,
} from "../../Helper/Constants";
import { getUserInfo } from "../../AuthUtils/AuthUtils";
import GetSvgIcon, {
  GetSvgBuilding,
  GetSvgLocationfill,
  GetSvgPerson,
  GetSvgPhone,
} from "../../../images/svglist";
import { getValue } from "@testing-library/user-event/dist/utils";
import { API_URI } from "../../../ConfigConstants/UrlConstants";
import Toggler from "../../Utilities/Toggler";
import moment from "moment";
import { numberInputOnWheelPreventChange } from "../../Helper/CommonMethods";
import { DownloadFile } from "../../Helper/FileStoreService";

const CharteredRateSummary = ({
  openConfirmAlert,
  ChartRateModalConfig,
  closeChartRateConfig,
  rateOrdDetails,
  setShowSpinner,
  openPopup,
  custCreditInfo,
  setOrdValue = () => {},
  setPayType = () => {},
  payType,
  handleCxlShipment,
  setCreditUse,
  creditUse,
}) => {
  const [rateOrderDetails, setRateOrderDetails] = useState([]);
  const isCust = LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(
    getUserInfo("userType")
  );
  const [stops, setStops] = useState([]);
  const [isSpecial, setIsSpecial] = useState(false);
  const [showDistance, setShowDistance] = useState(false);
  const [insuranceData, setInsuranceData] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const {
    control,
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "services",
  });

  useEffect(() => {
    getRate();
  }, [rateOrdDetails]);
  // const useCredit = watch("creditUse");
  const creditBalance = -custCreditInfo?.payment_due;

  const handleCloseRateModal = () => {
    reset();
    closeChartRateConfig();
  };
  const getRate = async () => {
    if (!!rateOrdDetails.order_id) {
      setShowSpinner(true);
      const resp = await CallApiGet(
        API_URI.GET_CH_ORD_DTLS + "?ordId=" + rateOrdDetails.order_id
      );
      if (resp.respCode === 200) {
        setRateOrderDetails(resp?.respData[0]);
        setOrdValue(resp?.respData[0]);
        setStops(
          !!resp?.respData[0]?.stops_data &&
            JSON.parse(resp?.respData[0]?.stops_data)
        );
        setShowDistance(
          !!resp?.respData[0]?.order_info &&
            JSON.parse(resp?.respData[0]?.order_info).filter(
              (a) => a.infoCode === 171
            )[0]?.infoValue
        );
        if (resp?.respData[0]?.rate_data) {
          const parsedRateData = JSON.parse(resp.respData[0].rate_data);
          setValue("services", parsedRateData);
        }
        setInsuranceData(JSON.parse(resp?.respData[0]?.insurance));
        let attachmentData =
          !!resp?.respData[0]?.attachment_data &&
          JSON.parse(resp?.respData[0]?.attachment_data);

        const groupByAttGroup = attachmentData
          ? attachmentData.reduce((attchMap, attch) => {
              if (!!attch.att_id) {
                if (!attchMap[attch.attachment_group]) {
                  attchMap[attch.attachment_group] = [];
                }
                attchMap[attch.attachment_group].push(attch);
              }

              return attchMap;
            }, {})
          : [];

        const attachArr = Object.keys(groupByAttGroup).map((attGroup) => ({
          attGroup,
          attchObj: groupByAttGroup[attGroup],
        }));
        setAttachments([...attachArr]);
      }
      setShowSpinner(false);
    } else {
      setValue("services", JSON.parse(JSON.stringify([])));
    }
  };

  const getCustomSortValue = (stop) => {
    switch (stop.stop_seq) {
      case 0:
        return 0;
      case 99:
        return 1;
      default:
        return stop.stop_seq + 1;
    }
  };

  // Sort stops based on the sequence
  const sortedStops = [...(stops || [])].sort((a, b) => {
    return getCustomSortValue(a) - getCustomSortValue(b);
  });

  const stopsView = () => {
    let stopBoxes = [];
    for (let i = 0; i < sortedStops.length; i++) {
      let stopData = sortedStops[i];
      let stopName = "Origin";
      if (stopData?.stop_seq === 99) stopName = "Destination";
      else if (stopData?.stop_seq > 0) stopName = `Stop ${stopData?.stop_seq}`;

      // Push each stop into stopBoxes as a column element
      stopBoxes.push(
        <div className="col-md-6 mb-2" key={i}>
          <div className="grd-bg p-3 rounded-3">
            <div className="fw-bold mb-1">{stopName}</div>
            <div className="theme-blue-txt">
              {stopData?.stop_cust_name && (
                <div className="d-flex align-items-center mb-1">
                  <span className="d-flex align-items-center theme-blue-txt me-2">
                    {GetSvgPerson(false)}
                  </span>
                  <div className="font-14">{stopData.stop_cust_name}</div>
                </div>
              )}
              {stopData?.stop_cust_phone && (
                <div className="d-flex align-items-center mb-1">
                  <span className="theme-blue-txt me-2">
                    {GetSvgPhone(false)}
                  </span>
                  <div className="font-14">{stopData.stop_cust_phone}</div>
                </div>
              )}
              {(stopData?.stop_address ||
                stopData?.stop_city ||
                stopData?.stop_state ||
                stopData?.stop_postcode) && (
                <div className="d-flex align-items-start mb-1">
                  <span className="theme-blue-txt me-2 mt-1 d-flex align-items-start">
                    {GetSvgBuilding(false)}
                  </span>
                  <div className="font-14">
                    {[
                      stopData?.stop_address,
                      stopData?.stop_city,
                      stopData?.stop_state,
                      stopData?.stop_postcode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </div>
                </div>
              )}
              {(stopData?.stop_lat || stopData?.stop_long) && (
                <div className="d-flex align-items-center">
                  <span className="theme-blue-txt me-2">
                    {GetSvgLocationfill()}
                  </span>
                  <div className="font-14 d-flex gap-3">
                    <span>Latitude: {stopData?.stop_lat || "-"}</span>
                    <span>Longitude: {stopData?.stop_long || "-"}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    // Group every two stopBoxes into a row
    const rows = [];
    for (let i = 0; i < stopBoxes.length; i += 2) {
      rows.push(
        <div className="row w-100" key={`row-${i}`}>
          {stopBoxes[i]}
          {i + 1 < stopBoxes.length ? stopBoxes[i + 1] : null}
        </div>
      );
    }

    // Return the grouped rows
    return <>{rows}</>;
  };

  const getSrvcCondition = (service) => {
    switch (service.serviceId) {
      case 0:
        return {
          label: "Base Charge",
          isCharge: true,
          isUnitPrice: false,
        };
      case CH_SRVC_TYPE.PIECES:
        return {
          label: service.unitTypeText,
          isCharge: false,
          isUnitPrice: true,
        };
      case CH_SRVC_TYPE.VHCLTYPE:
      case CH_SRVC_TYPE.OTHERCHRG:
        return {
          label: service.rateRefName,
          isCharge: true,
          isUnitPrice: false,
        };
      case CH_SRVC_TYPE.TAILGATE:
        return {
          label: service.serviceType,
          isCharge: true,
          isUnitPrice: false,
        };
      case CH_SRVC_TYPE.STOPCHG:
        return {
          label: `Stop ${service.serviceInfo} Charge`,
          isCharge: true,
          isUnitPrice: false,
        };
      default:
        return {
          label: service?.serviceType,
          isCharge: false,
          isUnitPrice: true,
        };
    }
  };

  const getTolAmt = (service, index) => {
    return !!(
      watch(`services.${index}.serviceValue`) *
      watch(`services.${index}.serviceUnitPrice`)
    )
      ? (+(
          watch(`services.${index}.serviceValue`) *
          watch(`services.${index}.serviceUnitPrice`)
        ))?.toFixed(2)
      : 0;
  };

  const checkForMinimum = (service) => {
    return service.serviceId === CH_SRVC_TYPE.OTHERCHRG ? 0 : 0;
  };

  const ServiceRow = (service, index) => {
    const charges = service.charges;
    const unitPrice = service.serviceUnitPrice;
    const total = charges * unitPrice;
    return (
      <>
        {service?.serviceId > 0 &&
          service.serviceId !== CH_SRVC_TYPE.STOPCHG && (
            <Row id={service.id} className="mt-1">
              <Col md={3} className="text-start">
                {service?.serviceId === CH_SRVC_TYPE.OTHERCHRG &&
                service?.correlationId === 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Other Service"
                      {...register(`services.${index}.rateRefName`, {
                        required: {
                          value: true,
                          message: REQUIRED_ERR_MSG,
                        },
                        pattern: {
                          value: ALPHABET_REGEX,
                          message: "Accepts Alphabets!",
                        },
                      })}
                    />
                    {errors?.services?.[index]?.serviceName && (
                      <span className="text-danger fw-bold font-12">
                        &#9888;{" "}
                        {errors?.services?.[index]?.serviceName?.message}
                      </span>
                    )}
                  </>
                ) : (
                  <label className="form-label theme-label">
                    {getSrvcCondition(service)?.label}
                  </label>
                )}
              </Col>
              <Col md={3} className="text-center">
                <input
                  type="number"
                  className="form-control"
                  {...register(`services.${index}.serviceValue`, {
                    required: {
                      value: true,
                      message: REQUIRED_ERR_MSG,
                    },
                    min: {
                      value: checkForMinimum(service),
                      message: REQUIRED_ERR_MSG,
                    },
                    pattern: {
                      value: NUMBER_NINE_DECIMAL,
                      message: PATTERN_ERR_MSG,
                    },
                  })}
                  readOnly={
                    service?.serviceId !== CH_SRVC_TYPE.OTHERCHRG ||
                    service?.correlationId >= 0
                  }
                  onWheel={(e) => numberInputOnWheelPreventChange(e)}
                />
                {errors?.services?.[index]?.serviceValue && (
                  <span className="text-danger fw-bold font-12">
                    &#9888; {errors?.services?.[index]?.serviceValue?.message}
                  </span>
                )}
              </Col>
              <Col md={3} className="text-center">
                <Row>
                  <Col md={10} className="pe-1">
                    <input
                      type="number"
                      className="form-control"
                      {...register(`services.${index}.serviceUnitPrice`, {
                        required: {
                          value: true,
                          message: REQUIRED_ERR_MSG,
                        },
                        // min: {
                        //   value: [
                        //     CH_SRVC_TYPE.OTHERCHRG,
                        //     CH_SRVC_TYPE.TAILGATE,
                        //     CH_SRVC_TYPE.EXTRAMANPOWER,
                        //   ].includes(service?.serviceId)
                        //     ? 0
                        //     : 1,
                        //   message: "Please input value greater than 0",
                        // },
                        min: {
                          value: 0,
                          message: "Negative value is not allowed",
                        },
                        pattern: {
                          value: NUMBER_NINE_DECIMAL,
                          message: PATTERN_ERR_MSG,
                        },
                      })}
                      maxLength={12}
                      disabled={isCust}
                      onWheel={(e) => numberInputOnWheelPreventChange(e)}
                    />
                  </Col>
                  <Col md={2} className="ps-0 d-flex align-items-center">
                    <label className="form-label theme-label align-middle mb-0">
                      RM
                    </label>
                  </Col>
                  {errors?.services?.[index]?.serviceUnitPrice && (
                    <span className="text-danger fw-bold font-12">
                      &#9888;{" "}
                      {errors?.services?.[index]?.serviceUnitPrice?.message}
                    </span>
                  )}
                </Row>
              </Col>
              <Col
                md={2}
                className="text-center d-flex align-items-center justify-content-center"
              >
                <label className="form-label theme-label text-center align-middle mb-0 pe-1">
                  {getTolAmt(service, index)}
                </label>
                <label className="form-label theme-label text-center align-middle mb-0">
                  RM
                </label>
              </Col>
              {service?.serviceId === CH_SRVC_TYPE.OTHERCHRG &&
                service?.correlationId === 0 && (
                  <Col md={1} className="d-flex align-items-center">
                    <label
                      className="form-label theme-label"
                      onClick={() => remove(index)}
                    >
                      {GetSvgIcon("DashCircleFill")}
                    </label>
                  </Col>
                )}
            </Row>
          )}
      </>
    );
  };

  const saveRate = async (formData) => {
    setShowSpinner(true);
    const payload = {
      shipmentId: rateOrdDetails?.order_id,
      customerId: rateOrdDetails?.customer_id,
      vas: [...formData.services],
      route: {
        id: rateOrdDetails.routeId,
        specialCommission: isSpecial,
        oneDriverComm: formData.oneDriverComm,
        twoDriverComm: formData.twoDriverComm,
      },
    };
    const data = await CallApiPost(API_URI.DEF_RATE_FOR_CH_ORD, payload);
    if (data.respCode === 200) {
      handlePostApiCall(data, "Chartered Rate saved successfully");
      handleCloseRateModal();
    } else {
      console.error("Failed to save Chartered VAS", data.respMessage);
    }
    setShowSpinner(false);
  };

  const handlePostApiCall = (resp, sucMsg) => {
    switch (resp.respCode) {
      case 200:
        openPopup(resp, "SUCCESS", sucMsg);
        break;
      case 500:
        openPopup(resp, "ERROR", resp.respMessage || SERVER_ERR_MSG);
        break;
      case 401:
        openPopup(
          false,
          "UNAUTHORIZED",
          "Sorry, you don't have the write permission!!"
        );
        break;
      case 99:
        openPopup(
          false,
          "ERROR",
          "Something went wrong. Please try after soemtime!!"
        );
        break;
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };

  const getButtonText = () => {
    if (LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))) {
      let totalAmt = (
        +fields.reduce((a, c, i) => a + +getTolAmt(c, i), 0) +
        +fields.find((rt) => rt.serviceId === 0)?.charges +
        rateOrderDetails?.sst
      ).toFixed(2);

      if (
        rateOrderDetails?.statusId === 625 &&
        rateOrderDetails?.rate_type !== 763
      ) {
        setPayType("");
        return "Confirm Rate";
      } else {
        if (custCreditInfo?.cust_type === 135) {
          setPayType("CASH");
          return "Confirm and Pay";
        } else {
          if (!custCreditInfo?.is_credit) {
            setPayType("CASH");
            return "Confirm and Pay";
          } else {
            if (custCreditInfo?.status_code === "CRED") {
              setPayType("CREDIT");
              return "Confirm";
            }
            if (custCreditInfo?.status_code === "CASH") {
              setPayType("CASH");
              return "Confirm and Pay";
            } else {
              if (custCreditInfo?.curr_credit_limit >= totalAmt) {
                setPayType("CREDIT");
                return "Confirm";
              } else {
                setPayType("CASH");
                return "Confirm and Pay";
              }
            }
          }
        }
      }
    } else {
      return "SAVE";
    }
  };
  const onError = (err) => {
    console.error(err);
  };

  const handleButtonClick = () => {
    if (LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))) {
      rateOrdDetails.rate_type = rateOrderDetails.rate_type;
      openConfirmAlert(rateOrdDetails);
    } else {
      handleSubmit(saveRate, onError)();
    }
  };

  const getSst = (amt, sst) => {
    if (sst > 0) {
      const sstValue = (amt * sst) / 100;
      const sstValueRounded = Math.round(sstValue * 100) / 100; // Round to 2 decimal places
      return sstValueRounded;
    } else {
      return 0;
    }
  };
  const togglerHandler = (label, value) => {
    setIsSpecial(!value);
    if (value === false) {
      setValue("oneDriverComm", 0);
      setValue("twoDriverComm", 0);
    }
  };

  const ServiceLabel = (rt) => (
    <label className="form-label theme-label">
      {getSrvcCondition(rt)?.label}
      <span className="text-danger">&#9733;</span>
      <br />
      <span>{GetSvgIcon("ToolTip")} </span>
      <span className="form-label font-12 text-danger " htmlFor="">
        maxlength 11 with a value of two decimals
      </span>
    </label>
  );

  const ServiceInput = (index) => (
    <input
      className="form-control"
      type="number"
      name={`services.${index}.charges`}
      {...register(`services.${index}.charges`, {
        required: {
          value: true,
          message: REQUIRED_ERR_MSG,
        },
        pattern: {
          value: NUMBER_NINE_DECIMAL,
          message: PATTERN_ERR_MSG,
        },
        validate: (v) => (v >= 0 ? true : REQUIRED_ERR_MSG),
      })}
      disabled={isCust}
      onWheel={(e) => numberInputOnWheelPreventChange(e)}
    />
  );

  const onSuccess = (title, body) => {
    console.log("title", title, "body", body);
  };

  const RenderAttch = ({ attachments, DownloadFile }) => {
    return (
      <Row className="mx-0">
        {!!attachments &&
          attachments.length > 0 &&
          attachments?.map((a, i) => (
            <Col className="grd-bg p-2 my-2 rounded-3 mb-1 mt-3">
              <>
                <span className="fw-bold">{a.attGroup}</span>
                {!!a.attchObj &&
                  a.attchObj
                    .sort((obj1, obj2) =>
                      obj1.att_name.localeCompare(obj2.att_name)
                    )
                    .map((o, i) => (
                      <div className="theme-blue-txt d-flex align-items-center justify-content-between">
                        <span className="fw-bold me-2">{o.att_name}</span>
                        <span className="theme-blue-txt me-2">{o.att_url}</span>
                        <button
                          type="button"
                          className="btn btn-outline theme-blue-txt bi bi-download ms-2"
                          onClick={() =>
                            DownloadFile(o.att_url, onSuccess, onError)
                          }
                        >
                          {GetSvgIcon("IconFiledownload")}
                        </button>
                      </div>
                    ))}
              </>
            </Col>
          ))}
      </Row>
    );
  };

  const getTotal = () => {
    return (
      +watch("services")?.reduce((a, c, i) => a + +getTolAmt(c, i), 0) +
      +watch("services")?.reduce(
        (a, c) =>
          [0, CH_SRVC_TYPE.STOPCHG].includes(c.serviceId) ? a + +c.charges : a,
        0
      ) +
      +insuranceData?.charge
    );
  };

  const totalIncludingSST = (
    getTotal() + getSst(getTotal(), rateOrderDetails?.sst)
  ).toFixed(2);
  let totalToPay;
  if (creditUse) {
    totalToPay =
      creditBalance >= totalIncludingSST
        ? 0
        : totalIncludingSST - creditBalance;
  }
  return (
    <>
      <Modal
        show={ChartRateModalConfig}
        onHide={handleCloseRateModal}
        fullscreen={true}
      >
        <Modal.Header closeButton>
          <Modal.Title className="section-title">
            Chartered Rate Configuration
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Row>
                <Col>
                  <div class="grd-bg p-2 p my-2 rounded-3">
                    <div class="fw-bold">Route Code</div>
                    <div class="theme-blue-txt">
                      {rateOrderDetails?.routeCode}
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold"> Chartered Date</div>
                    <div className="theme-blue-txt">
                      {rateOrderDetails?.booked_on}
                    </div>
                  </div>
                </Col>

                <Col>
                  <div className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Rate Type</div>
                    <div className="theme-blue-txt">
                      {rateOrderDetails?.rate_type_val}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>{stopsView()}</Row>
              <Row>
                <Col>
                  <div className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Remarks</div>
                    <div className="theme-blue-txt">
                      {rateOrderDetails?.remarks}
                    </div>
                  </div>
                </Col>
              </Row>
              {rateOrdDetails?.orderType === AD_HOC_CH_ORDER && (
                <Row>
                  <Col>
                    <div className="grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Distance</div>
                      <div className="theme-blue-txt">
                        {!!showDistance ? showDistance : 0} KM
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
              {!!insuranceData && insuranceData?.packageId?.length > 0 && (
                <Row className="ps-2">
                  <Col className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Package Id</div>
                    <div className="theme-blue-txt">
                      {insuranceData?.packageId}
                    </div>
                  </Col>
                  <Col className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Coverage Upto</div>
                    <div className="theme-blue-txt">
                      {insuranceData?.coverage} RM
                    </div>
                  </Col>
                  <Col className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Insurance Fee</div>
                    <div className="theme-blue-txt">
                      {insuranceData?.charge} RM
                    </div>
                  </Col>
                  <Col className="grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Insurance Declared Price</div>
                    <div className="theme-blue-txt">
                      {insuranceData?.insDeclaredPrice} RM
                    </div>
                  </Col>
                </Row>
              )}
              {attachments.length > 0 && (
                <Row>
                  <RenderAttch
                    attachments={attachments}
                    DownloadFile={DownloadFile}
                  />
                </Row>
              )}
              {!isCust && (
                <>
                  <Row className="fw-bold mt-3 theme-violet-txt">
                    <h6>COMMISSION CONFIGURATION</h6>
                    <Toggler
                      btnName="btn_from"
                      isBtn1Checked={!isSpecial}
                      isBtn2Checked={isSpecial}
                      btn1Value={true}
                      btn2Value={false}
                      btn1Label="Normal"
                      btn2Label="Special"
                      handler={togglerHandler}
                    />
                  </Row>
                  <>
                    {isSpecial && (
                      <Row className="mt-1">
                        <Col className="form-label theme-label">
                          <label>Driver1 Commission</label>
                          <input
                            className="form-control"
                            type="text"
                            {...register("oneDriverComm", {
                              pattern: {
                                value: NUMBER_NINE_DECIMAL,
                                message: PATTERN_ERR_MSG,
                              },
                            })}
                          />
                          {errors?.oneDriverComm && (
                            <div>
                              <span className="text-danger fw-bold font-12">
                                &#9888; {errors?.oneDriverComm?.message}
                              </span>
                            </div>
                          )}
                        </Col>
                        <Col className="form-label theme-label">
                          <label>Driver2 Commission</label>
                          <input
                            className="form-control"
                            type="text"
                            {...register("twoDriverComm", {
                              pattern: {
                                value: NUMBER_NINE_DECIMAL,
                                message: PATTERN_ERR_MSG,
                              },
                            })}
                          />
                          {errors?.twoDriverComm && (
                            <div>
                              <span className="text-danger fw-bold font-12">
                                &#9888; {errors?.twoDriverComm?.message}
                              </span>
                            </div>
                          )}
                        </Col>
                      </Row>
                    )}
                  </>
                </>
              )}
            </Col>
            <Col md={6}>
              <Row className="fw-bold theme-violet-txt border-bottom">
                <h5>FARE DETAILS</h5>
              </Row>
              {fields.map((rt, index) => (
                <>
                  {rt.serviceId === 0 && (
                    <Row className="mt-3" key={rt.id}>
                      <Col md={5}>{ServiceLabel(rt)}</Col>
                      <Col md={4}>
                        <div className="row">
                          <div className="col-md-10 pe-1">
                            {ServiceInput(index)}
                            {!!errors?.services &&
                              !!errors?.services[index] && (
                                <div>
                                  <span className="text-danger fw-bold font-12">
                                    &#9888;{" "}
                                    {errors?.services[index]?.charges?.message}
                                  </span>
                                </div>
                              )}
                          </div>
                          <div className="col-md-2 ps-0 d-flex align-items-center">
                            <label className="form-label theme-label align-middle">
                              RM
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </>
              ))}
              <Row className="mt-1">
                {fields.map((rt, index) => (
                  <>
                    {rt.serviceId === CH_SRVC_TYPE.STOPCHG && (
                      <Col md={6} key={rt.id}>
                        {ServiceLabel(rt)}
                        <Row>
                          <Col className="pe-1">{ServiceInput(index)}</Col>
                          <Col
                            md={1}
                            className="ps-0 d-flex align-items-center"
                          >
                            <label className="form-label theme-label align-middle">
                              RM
                            </label>
                          </Col>
                        </Row>

                        {!!errors?.services && !!errors?.services[index] && (
                          <div>
                            <span className="text-danger fw-bold font-12">
                              &#9888;{" "}
                              {errors?.services[index]?.charges?.message}
                            </span>
                          </div>
                        )}
                      </Col>
                    )}
                  </>
                ))}
              </Row>
              <Row className="border-top border-bottom my-2">
                <Col md={3} className="text-start">
                  <label className="form-label theme-label">Service</label>
                </Col>
                <Col md={3} className="text-center">
                  <label className="form-label theme-label ">Value</label>
                </Col>
                <Col md={3} className="text-center">
                  <label className="form-label theme-label">Unit Price</label>
                </Col>
                <Col md={2} className="text-center">
                  <label className="form-label theme-label">Total</label>
                </Col>
                {rateOrderDetails?.statusId === ORD_STS.AWAIT_RATE_INFO &&
                  !isCust && (
                    <Col
                      md={1}
                      className="text-center d-flex align-items-center"
                    >
                      <label
                        className="form-label theme-label align-middle text-center"
                        onClick={() => {
                          let copySrvcObj = Object.assign({}, initSrvcObj);
                          copySrvcObj.serviceValue = 1;
                          copySrvcObj.serviceId = CH_SRVC_TYPE.OTHERCHRG;
                          copySrvcObj.serviceCode =
                            "CH" + moment().format("YYMMDDHHmmss");
                          append(copySrvcObj);
                        }}
                      >
                        {GetSvgIcon("PlusCircle")}
                      </label>
                    </Col>
                  )}
              </Row>
              {fields.map(
                (item, index) => ServiceRow(item, index) // Call the ServiceRow function to render each service row
              )}
              <Row className="border-bottom my-2"></Row>
              {/* {payType === "CASH" && (
                <Row className="mt-2">
                  <Col className="text-start align-middle">
                    <input
                      type="checkbox"
                      id="useCredit"
                      className="me-2"
                      onClick={(e) => setCreditUse(e.target.checked)}
                    />
                    <label md={3} className="form-label theme-label">
                      Apply Available Credit Balance: ({creditBalance}) RM
                    </label>
                  </Col>
                </Row>
              )} */}

              <Row>
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}>
                  <Row className="text-end">
                    <label className="form-label theme-label">
                      Service Charges :
                    </label>
                  </Row>
                  <Row className="text-end">
                    <label className="form-label theme-label">
                      Base Charge :
                    </label>
                  </Row>
                  <Row className="text-end">
                    <label className="form-label theme-label">
                      Stop Charges :
                    </label>
                  </Row>
                  {!!insuranceData && insuranceData?.packageId?.length > 0 && (
                    <Row className="text-end">
                      <label className="form-label theme-label">
                        Insurance :
                      </label>
                    </Row>
                  )}
                  <Row className="text-end">
                    <hr />
                  </Row>
                  <Row className="text-end">
                    <label className="form-label theme-label">
                      Sub Total :
                    </label>
                  </Row>
                  <Row className="text-end">
                    <label className="form-label theme-label">SST :</label>
                  </Row>
                  <Row className="text-end">
                    <label className="form-label theme-label">Total :</label>
                  </Row>
                  {creditUse && (
                    <Row className="text-end">
                      <label className="form-label theme-label">
                        Total Amount to Pay:
                      </label>
                    </Row>
                  )}
                </Col>
                <Col md={2}>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {(+watch("services")?.reduce(
                        (a, c, i) => a + +getTolAmt(c, i),
                        0
                      ))?.toFixed(2)}{" "}
                      RM
                    </label>
                  </Row>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {(+watch("services")?.find((rt) => rt.serviceId === 0)
                        ?.charges)?.toFixed(2)}{" "}
                      RM
                    </label>
                  </Row>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {(+watch("services")?.reduce(
                        (a, c) =>
                          c.serviceId === CH_SRVC_TYPE.STOPCHG
                            ? a + +c?.charges
                            : a,
                        0
                      ))?.toFixed(2)}
                      RM
                    </label>
                  </Row>
                  {!!insuranceData && insuranceData?.packageId?.length > 0 && (
                    <Row className="text-center">
                      <label className="form-label theme-label">
                        {insuranceData?.charge} RM
                      </label>
                    </Row>
                  )}
                  <Row className="text-end">
                    <hr />
                  </Row>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {getTotal()?.toFixed(2)} RM
                    </label>
                  </Row>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {getSst(getTotal(), rateOrderDetails?.sst)?.toFixed(2)} RM
                    </label>
                  </Row>
                  <Row className="text-center">
                    <label className="form-label theme-label">
                      {(
                        getTotal() + getSst(getTotal(), rateOrderDetails?.sst)
                      ).toFixed(2)}{" "}
                      RM
                    </label>
                  </Row>
                  {creditUse && (
                    <Row className="text-center">
                      <label className="form-label theme-label">
                        {totalToPay.toFixed(2)}
                        RM
                      </label>
                    </Row>
                  )}
                </Col>
                <Col md={1}></Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType")) &&
          rateOrdDetails?.statusId === 625 ? (
            <Button
              variant="primary"
              className="theme-red"
              onClick={() =>
                handleCxlShipment({ orderId: rateOrdDetails?.order_id })
              }
            >
              Reject
            </Button>
          ) : (
            rateOrdDetails?.ordStatus === 623 && (
              <Button
                variant="primary"
                className="theme-red"
                onClick={() =>
                  handleCxlShipment({ orderId: rateOrdDetails?.order_id })
                }
              >
                Reject
              </Button>
            )
          )}
          <Button
            variant="primary"
            className="theme-violet"
            onClick={handleButtonClick}
          >
            {getButtonText()}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CharteredRateSummary;
